export default __webpack_public_path__ + "static/media/miguel-lopes-34.942f981e.jpg";